/**
 * @description:
 * @since: 2022-04-08 11:56:00
 */
import type { Router } from 'vue-router'

import { createRouter, createWebHistory } from 'vue-router'
import { routerGuard } from './guard'
import { routes } from './routes'

const router: Router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  strict: true,
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title}`
  }

  next()
})

routerGuard(router)

export default router
